import axios from 'axios'
import exceptionHandler from '@/common/exception-handler'

const getCompanies = () => {
  return axios.get('/api/companies/')
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

const getCompany = companyId => {
  return axios.get(`/api/companies/${companyId}`)
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

const getAppVersion = companyId => axios.get(`/api/companies/${companyId}/appVersion`)
  .then(res => res.data)
  .catch(error => exceptionHandler.parse(error))

const createCompany = company => {
  return axios.post('/api/companies/', company)
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

const editCompany = company => {
  return axios.put('/api/companies/', company)
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

const deleteCompany = companyId => {
  return axios.post(`/api/companies/${companyId}/delete`)
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

const updateJobTypeDepartment = (companyId, jobTypeDepartment) => {
  return axios.put(`/api/companies/${companyId}/jobTypeDepartment`, jobTypeDepartment)
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

const getThirdPartyIntegrationUrl = companyId => {
  return axios.get(`/api/companies/thirdPartyIntegrationUrl/${companyId}`)
    .then(res => res.data)
    .catch(error => exceptionHandler.parse(error))
}

export default {
  getCompanies,
  getCompany,
  createCompany,
  editCompany,
  deleteCompany,
  getAppVersion,
  updateJobTypeDepartment,
  getThirdPartyIntegrationUrl
}
